enum AccountWorkspaceStatus {
    Active = "active",
    Suspended = "suspended",
    Frozen = "frozen"
}

export default interface AccountWorkspace {
    _id: string;
    status: AccountWorkspaceStatus;
    name: string;
    logo?: string;
    projectCount: number;
    paidSeatCount: number;
    paidMemberCount: number;
    reviewerCount: number;
}

export {
    AccountWorkspaceStatus
};
